import {
  Dispatch,
  SetStateAction,
  useCallback,
  useState,
  useEffect
} from "react";
import React from "react";
import ReactPlayer from "react-player";
import "../../../styles.css";
import { VideoContainer } from "./ClassSpotlightView.css";

interface SpotlightVideoProps {
  switchPlayerToGrid: (videoRef: React.RefObject<ReactPlayer>) => void;
  playPauseHandler: () => void;
  playing: boolean;
  loop: boolean;
  muted: boolean;
  ref1: React.RefObject<ReactPlayer>;
  ref2: React.RefObject<ReactPlayer>;
  ref3: React.RefObject<ReactPlayer>;
  ref4: React.RefObject<ReactPlayer>;
  links: {
    url1: string;
    url2: string;
    url3: string;
    url4: string;
  };
  spotlight: number;
  setSpotlight: React.Dispatch<React.SetStateAction<number>>
  handleProgress: (event: any) => void;
  volume: number;
  updateRefsWithCurrentTime: (value: number) => void;
  updateSpotlight: (videoNumber: number, currentTime: number) => void;
}

function ClassSpotlightView({
  switchPlayerToGrid,
  playPauseHandler,
  playing,
  loop,
  muted,
  ref1,
  ref2,
  ref3,
  ref4,
  links,
  spotlight,
  setSpotlight,
  handleProgress,
  volume,
  updateRefsWithCurrentTime,
  updateSpotlight
}: SpotlightVideoProps) {
  const getUrl = (videoNumber: number) => {
    if (videoNumber === 1) {
      switch (spotlight) {
        case 1:
          return links.url1;
        case 2:
          return links.url2;
        case 3:
          return links.url3;
        case 4:
          return links.url4;
        default:
          return links.url1;
      }
    } else if (videoNumber === 2) {
      switch (spotlight) {
        case 1:
          return links.url2;
        case 2:
          return links.url1;
        case 3:
          return links.url1;
        case 4:
          return links.url1;
        default:
          return links.url1;
      }
    } else if (videoNumber === 3) {
      switch (spotlight) {
        case 1:
          return links.url3;
        case 2:
          return links.url3;
        case 3:
          return links.url2;
        case 4:
          return links.url2;
        default:
          return links.url1;
      }
    } else {
      switch (spotlight) {
        case 1:
          return links.url4;
        case 2:
          return links.url4;
        case 3:
          return links.url4;
        case 4:
          return links.url3;
        default:
          return links.url1;
      }
    }
  };

  let clickTimeout = null;

  useEffect(() => {
    clickTimeout = null;
  }, []);

  const handleSpotlightClicks = ({target}: any, videoRef: React.RefObject<ReactPlayer>) => {
    if (isNaN(target.cn)) {
      target.cn = 1 
    } else {
      target.cn++
    }
    setTimeout(() => {
      if (target.cn == 1) {
        //console.log('single');
        playPauseHandler();
        target.cn = 0
      }
      if (target.cn > 1) {
        //console.log('double');
        switchPlayerToGrid(videoRef);
        target.cn = 0
      }
    }, 500)
  };

  const handlePanelClicks = ({target} : any, url: string, videoRef: React.RefObject<ReactPlayer>) => {
    if (isNaN(target.cn)) {
      target.cn = 1 
    } else {
      target.cn++
    }
    setTimeout(() => {
      if (target.cn == 1) {
        //console.log('single');
        playPauseHandler();
        target.cn = 0
      }
      if (target.cn > 1) {
        //console.log('double');
        let videoNumber = 1;
        switch (url) {
          case links.url1:
            videoNumber = 1;
            break;
          case links.url2:
            videoNumber = 2;
            break;
          case links.url3:
            videoNumber = 3;
            break;
          case links.url4:
            videoNumber = 4;
            break;
          default:
            videoNumber = 1;
        }
        //setSpotlight(videoNumber);
        updateSpotlight(videoNumber, videoRef.current?.getCurrentTime());
        target.cn = 0
      }
    }, 500)  
  };

  return (
    <VideoContainer>
      <div
        className="player__wrapper"
        onClick={(event) => handleSpotlightClicks(event, ref1)}
      >
        <ReactPlayer
          ref={ref1}
          className="player"
          url={getUrl(1)}
          width="100%"
          height="100%"
          playing={playing}
          loop={loop}
          volume={volume}
          muted={muted}
          controls={false}
          onProgress={handleProgress}
          progressInterval={100}
        />
      </div>
      <div className="secondaryVideosContainer">
        <div onClick={(event) => handlePanelClicks(event, getUrl(2), ref2)}>
          <ReactPlayer
            ref={ref2}
            url={getUrl(2)}
            width="100%"
            height="100%"
            playing={playing}
            loop={loop}
            volume={volume}
            muted={muted}
            controls={false}
          />
        </div>
        <div onClick={(event) => handlePanelClicks(event, getUrl(3), ref3)}>
          <ReactPlayer
            ref={ref3}
            url={getUrl(3)}
            width="100%"
            height="100%"
            playing={playing}
            loop={loop}
            volume={volume}
            muted={muted}
            controls={false}
          />
        </div>
        <div onClick={(event) => handlePanelClicks(event, getUrl(4), ref4)}>
          <ReactPlayer
            ref={ref4}
            url={getUrl(4)}
            width="100%"
            height="100%"
            playing={playing}
            loop={loop}
            volume={volume}
            muted={muted}
            controls={false}
          />
        </div>
      </div>
    </VideoContainer>
  );
}

export default ClassSpotlightView;
